import { EditUserClientDialog } from './../../dialogs/user-client-dialog/user-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { AuthenticationService } from '../../../services/authentication.service';
import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { NavigationService } from 'src/app/services/navigation.service';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { MatSidenavContainer, MatSidenav, MatSidenavContent } from '@angular/material/sidenav';
import { MatNavList, MatListItem } from '@angular/material/list';
import { MatIcon } from '@angular/material/icon';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { AvatarComponent } from '../../misc/avatar/avatar.component';
import { MenuItem } from 'src/app/services/navigation.service';

@Component({
    selector: 'app-logged-layout',
    templateUrl: './logged-layout.component.html',
    styleUrls: ['./logged-layout.component.scss'],
    imports: [MatSidenavContainer, MatSidenav, MatNavList, MatListItem, RouterLink, MatIcon, MatSidenavContent, MatToolbar, MatToolbarRow, MatIconButton, MatButton, MatMenuTrigger, AvatarComponent, MatMenu, MatMenuItem, RouterOutlet, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoggedLayoutComponent {
  public translate = inject(TranslateService);
  public auth = inject(AuthenticationService);
  public navService = inject(NavigationService);
  public dialog = inject(MatDialog);
  private breakpointObserver = inject(BreakpointObserver);
  private router = inject(Router);

  authUser = this.auth.authUser;
  user = this.auth.user;
  ready = computed(() => this.authUser() !== null);

  sideMenu = computed(() => this.navService.getMenu('main'));
  profileMenu = computed(() => this.navService.getMenu('profile'));

  isHandset = toSignal(
    this.breakpointObserver.observe(Breakpoints.Handset).pipe(map(result => result.matches)),
    { initialValue: false }
  );

  isItemVisible(item: MenuItem | null = null) {
    if (item && item.roles) {
      const authUser = this.authUser();
      return authUser && authUser.hasRole(item.roles)
    }
    return true;
  }

  goToProfile() {
    // if (this.authUser.hasRole(['babysitter'])) {
    //   this.router.navigate(['babysitter','profile']);

    // } else if (this.authUser.hasRole(['nanny'])) {
    //   this.router.navigate(['nanny','profile']);
    // } else {
    //   this.router.navigate(['family','profile']);
    // }
  }

  goToAccount() {
      let title = this.translate.instant('USER.MY_PROFILE');
      let user = this.auth.getCurrentUser();
      const dialogRef = this.dialog.open(EditUserClientDialog, {
        width: '550px',
        data: {
          title: title,
          item: user,
          me :true
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        this.auth.loadCurrentUser();
      });
  }

}
